import { FunctionComponent, useContext, useMemo } from 'react';
import { ChannelContext, ConfigContext } from '../../context';
import { ConfigurationLink, FooterCopy, IconLabelSizes, LayoutSwitcher } from '../../shared';

import classes from './Footer.module.scss';

export const Footer: FunctionComponent = () => {
  const { dashboardUrl } = useContext(ChannelContext);

  const { links } = useContext(ConfigContext).config.elements.footer;

  const renderFooterLinks = useMemo(
    () =>
      links.map((link) => (
        <ConfigurationLink
          key={link.title}
          link={link}
          labelSize={IconLabelSizes.small}
          labelClassName={classes['footer__links-item-label']}
        />
      )),
    [links]
  );

  return (
    <div className={classes['footer']}>
      {dashboardUrl && <LayoutSwitcher />}

      {Boolean(renderFooterLinks.length) && (
        <div className={classes['footer__links']}>{renderFooterLinks}</div>
      )}
      <FooterCopy />
    </div>
  );
};
